"use client"
import React, { useEffect, useState } from 'react'
import del from "./delete.module.css";
import watch from "../watchnow/watch.module.css"
import Link from 'next/link';
import { useAuthStore } from '../store/authstore';
import tohash from '../utils/tohash';
import { useRouter } from 'next/navigation';
import { useToastStore } from '../store/localapi';
import { fetchWithLoader } from '../utils/api';


export default function Deleteacc() {
    const user = useAuthStore((state) => state.user);
    const { showToast } = useToastStore()
    const router = useRouter();
     const [isClient, setIsClient] = useState(false);
    
      useEffect(() => setIsClient(true), []);
      useEffect(() => {
        // eslint-disable-next-line
        isClient && setTimeout(() => !user && router.push('/'), 50);
      }, [user, isClient, router]);

    const handleDeleteAccount = async() => {
        // Confirm deletion
        // if (!confirm("Are you sure you want to delete your account? This action cannot be undone.")) return;
        if (!user?.user_id) {
            console.error("User ID is not available.");
            return;
        }

        await fetchWithLoader('delete_user_otp.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: user.user_id }),
        })
            .then(response => response.json())
            .then(data => {
                if (data?.data.ErrorMessage === "user not Exists") {
                    showToast("User not Exist", "error")
                    return;
                }
                if (data?.data.ErrorMessage === "OTP send Successfully") {
                    const hash = tohash(data?.data?.Data?.otp.toString());
                    const final = `${hash?.slice(0, 5)}${data?.data?.Data?.otp}${hash?.slice(5)}`;
                    sessionStorage.setItem('_hash', `${final}`);
                    router.push(`/verifyotp?deleteacc=${user?.user_id}47cab1f3c8d2a`);
                    return
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

    return (
        <div>
            <div className={watch.watchNow}>
                <h2>Dashboard</h2>
            </div>

            <div className={del.dashboard}>
                <div className="container">

                    <div className={`${del.donebtn} ${del.DashboardContent}`}>
                        <div className={del.dashboardIcon}>
                            {user && user.user_image ?
                                // eslint-disable-next-line @next/next/no-img-element
                                <img src={user?.user_image} alt="User" />
                            :  <svg xmlns="http://www.w3.org/2000/svg" width="103" height="104" viewBox="0 0 103 104" fill="none">
                                <circle cx="51.7056" cy="52.1047" r="51.1829" fill="#E21220" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M51.7049 21.9678C44.7708 21.9678 39.1497 27.5889 39.1497 34.523C39.1497 41.4571 44.7708 47.0782 51.7049 47.0782C58.6389 47.0782 64.2601 41.4571 64.2601 34.523C64.2601 27.5889 58.6389 21.9678 51.7049 21.9678ZM44.1717 34.523C44.1717 30.3626 47.5445 26.9899 51.7049 26.9899C55.8654 26.9899 59.238 30.3626 59.238 34.523C59.238 38.6834 55.8654 42.0561 51.7049 42.0561C47.5445 42.0561 44.1717 38.6834 44.1717 34.523Z" fill="white" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M50.5888 52.1016C35.9502 52.1016 24.0833 63.9685 24.0833 78.6071C24.0833 80.6102 25.7071 82.2341 27.7103 82.2341H75.6993C77.7024 82.2341 79.3262 80.6102 79.3262 78.6071C79.3262 63.9685 67.4593 52.1016 52.8207 52.1016H50.5888ZM52.8207 57.1237C64.217 57.1237 73.5408 65.9972 74.2597 77.212H29.1499C29.8687 65.9972 39.1924 57.1237 50.5888 57.1237H52.8207Z" fill="white" />
                            </svg>
                            }
                        </div>
                        <h2>Are you sure you wanna delete your account?</h2>
                        <p>When you click on the delete button, you will lose all your account details that include your saved and in-progress dramas and profile information.Our support team will delete all the information associated with the following email address once your account is verified. Email...</p>
                        <p>Note: If you are subscribed to DramaFlicks Premium, you will need to unsubscribe from the App Store/ Play Store, since we don&#39;t control the billing process. If you don&#39;t cancel the subscription, you&#39;ll be automatically charged on the due date.</p>
                        <div className={del.deletStoreLinks}>
                            <p>To unsubscribe through Google Play, please read this <Link href="https://support.google.com/googleplay/answer/2476088?hl=en" target='/'>Google FAQ.</Link></p>
                            <p>To unsubscribe through Apple, please read this <Link href="https://support.apple.com/en-us/118428"  target='/'>Apple FAQ.</Link></p>
                            <p>To unsubscribe through PayPal, please read this <Link href="https://www.paypal.com/us/cshelp/article/what-is-an-automatic-payment-and-how-do-i-update-or-cancel-one-help240"  target='/'>PayPal FAQ.</Link></p>
                        </div>
                        <div className={del.editprofilebtn}>
                            <button type='button' className='commonBtn' onClick={handleDeleteAccount}>Delete Account</button>
                            <Link href="/dashboard">Go back</Link>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
}




